import React from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { Button, Dialog, TextArea } from '@app/components';

import {
  ModalContainer,
  ChecklistText,
  ChecklistInfoBox,
  Footer,
  ChecklistButtonContainer,
  CancelButton,
  ModalTextArea,
  SavingIndicator,
} from '@app/modules/transaction-details/transactions-details-components';

import { ActivityLogInfo } from '@app/types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';

import { useUpdateChecklistMutation } from '@app/graphql';

type Props = {
  onModalClose?: any;
  userFirebaseId: string;
  legalData: any;
  status?: string;
  loadChecklistData: (checklistData: any, pendingTasks: string) => void;
  getActivityLogData: (e: ActivityLogInfo[]) => void;
};
let activityLog: ActivityLogInfo[] = [];

export default function AdditionalQuestionsModal(props: Props) {
  const {
    onModalClose,
    userFirebaseId,
    loadChecklistData,
    legalData,
    status,
    getActivityLogData,
  } = props;
  const { register } = useForm();
  const { transactionId }: any = useParams();
  const [updateCheckList] = useUpdateChecklistMutation();
  const [legalDes, setLegalDes] = React.useState<string>('');
  const [saving, updatesaving] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (legalData) {
      activityLog = [];
      const { notes = '' } = legalData;
      setLegalDes(notes);
    }
  }, [legalData]);

  const getActivityLog = () => {
    if (status !== 'COMPLETED') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userFirebaseId,
        item: `Response`,
        description: 'for Legal Description task has been submitted by ',
      });
      return activityLog;
    } else {
      if (legalDes !== legalData.notes && status === 'COMPLETED') {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userFirebaseId,
          item: `Response`,
          description: 'for Legal Description task has been updated by ',
        });
        return activityLog;
      }
    }
    return activityLog;
  };

  const submitChecklistData = () => {
    updatesaving(true);
    const checklistVariables = {
      transactionId: transactionId,
      status: 'COMPLETED',
      userType: legalData && legalData.userType ? legalData.userType : '',
      completedAt: moment().format('YYYY-MM-DD'),
      firebaseId: userFirebaseId,
      assignmentChecklistKey: 'legalDescription',
      notes: legalDes,
      activityLog: getActivityLog(),
    };
    updateCheckList({
      variables: checklistVariables,
    }).then((res: any) => {
      if (res.data.updateTransactionChecklist.success) {
        const {
          updateTransactionChecklist: { transaction },
        } = res.data;
        const { assignmentChecklist, pendingTasks, activityLog } = transaction;
        loadChecklistData(assignmentChecklist, pendingTasks);
        getActivityLogData(activityLog);
        updatesaving(false);
        setTimeout(onModalClose, 100);
      }
    });
  };
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === 'legaldescription') {
      setLegalDes(e.target.value);
    }
  };

  return (
    <Dialog title="Legal Description" onClose={onModalClose}>
      <ModalContainer>
        <ChecklistText>Please enter Legal Description</ChecklistText>
        <ChecklistInfoBox>
          <ModalTextArea>
            <TextArea
              placeholder="Enter Description (any)"
              name="legaldescription"
              value={legalDes ? legalDes : ''}
              onChange={onChange}
              register={register({})}
            />
          </ModalTextArea>
        </ChecklistInfoBox>
      </ModalContainer>
      <Footer>
        {saving && (
          <SavingIndicator>
            <FontAwesomeIcon
              color={primaryColor}
              icon={faCircleNotch}
              size="lg"
              spin
            />
          </SavingIndicator>
        )}
        <CancelButton>
          <Button variant="text" size="medium" onClick={onModalClose}>
            Cancel
          </Button>
        </CancelButton>
        <ChecklistButtonContainer disabled={saving}>
          <Button
            variant="primary"
            size="medium"
            width="100%"
            type="submit"
            onClick={submitChecklistData}>
            Submit Task
          </Button>
        </ChecklistButtonContainer>
      </Footer>
    </Dialog>
  );
}
